<template>
  <div class="page">
    <div class="mainCard3">
      <div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 15px;">
          <div>
            <el-button v-if="isOrgCreator" type="primary" size="small" @click="openRoleDialog('add')">新建角色</el-button>
            <el-button type="primary" size="small" @click="loadRoleList">刷新</el-button>
          </div>
        </div>
        
        <!-- 角色管理表格 -->
        <el-table :data="roleTable" style="width: 100%" v-loading="roleLoading">
          <el-table-column prop="roleName" label="角色名称" width="180"></el-table-column>
          <el-table-column prop="roleRemark" label="角色描述"></el-table-column>
          <el-table-column prop="roleStatus" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.roleStatus === '0' ? 'success' : 'danger'">
                {{ scope.row.roleStatus === '0' ? '正常' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180">
            <template slot-scope="scope">
              <div>{{ scope.row.createTime | timestampToTime }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="openRoleDialog('edit', scope.row)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="text"
                @click="toggleRoleStatus(scope.row)"
              >{{ scope.row.roleStatus === '0' ? '停用' : '启用' }}</el-button>
              <el-button
                size="mini"
                type="text"
                @click="assignRole(scope.row)"
              >分配成员</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleDeleteRole(scope.row)"
                style="color: #F56C6C;"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 角色添加/编辑对话框 -->
    <el-dialog :title="roleDialogType === 'add' ? '新增角色' : '编辑角色'" :visible.sync="roleDialogVisible" width="60%" @closed="resetRoleForm">
      <el-form :model="roleForm" :rules="roleRules" ref="roleForm" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="roleRemark">
          <el-input v-model="roleForm.roleRemark" placeholder="请输入角色描述" type="textarea" :rows="2"></el-input>
        </el-form-item>
        
        <el-tabs type="border-card">
          <el-tab-pane label="功能权限">
            <el-form-item label="功能权限">
              <el-tree
                ref="powerTree"
                :data="powerList"
                :props="powerProps"
                show-checkbox
                node-key="powerId"
                :default-checked-keys="roleForm.powerId ? roleForm.powerId.split(',') : []"
                @check="handlePowerCheck">
              </el-tree>
            </el-form-item>
          </el-tab-pane>
          
          <el-tab-pane label="菜单权限">
            <el-form-item label="菜单权限">
              <el-tree
                ref="menuTree"
                :data="menuList"
                :props="menuProps"
                show-checkbox
                node-key="id"
                :default-expand-all="true"
                :default-checked-keys="roleForm.menuIds"
                :check-strictly="true"
                @check="handleMenuCheck"
                v-loading="menuLoading">
              </el-tree>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRoleForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 角色分配对话框 -->
    <el-dialog title="角色分配" :visible.sync="assignRoleDialogVisible" width="50%">
      <div v-loading="roleLoading">
        <el-tabs type="border-card">
          <el-tab-pane label="添加成员">
            <el-form label-width="80px">
              <el-form-item label="选择用户">
                <div v-if="systemCompanyUser0.length === 0" style="color: #999; line-height: 40px;">
                  暂无可添加的组织成员
                </div>
                <el-select
                  v-else
                  v-model="selectedUser"
                  filterable
                  placeholder="请选择用户"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in systemCompanyUser0"
                    :key="item.userId"
                    :label="getUserLabel(item)"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitAssignRole" :disabled="!selectedUser || systemCompanyUser0.length === 0">添加到角色</el-button>
                <el-button type="info" @click="loadOrgMembers">刷新成员列表</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="已分配成员">
            <div v-if="roleUsers.length === 0" style="text-align: center; padding: 20px;">
              <span>该角色暂无分配成员</span>
            </div>
            <el-table v-else :data="roleUsers" border>
              <el-table-column prop="user.userName" label="姓名">
                <template slot-scope="scope">
                  {{ getUserDisplayField(scope.row, 'userName') }}
                </template>
              </el-table-column>
              <el-table-column prop="user.userPhone" label="手机号">
                <template slot-scope="scope">
                  {{ getUserDisplayField(scope.row, 'userPhone') }}
                </template>
              </el-table-column>
              <el-table-column prop="user.userEmail" label="邮箱">
                <template slot-scope="scope">
                  {{ getUserDisplayField(scope.row, 'userEmail') }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button 
                    type="text" 
                    size="small" 
                    style="color: #F56C6C;" 
                    @click="removeUserFromRole(scope.row)"
                  >
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignRoleDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleList,
  getPowerList,
  addRole,
  editRole,
  deleteRole,
  getRoleUserList,
  addUserRole,
  deleteUserRole,
  enableOrDisableRole,
  getCompanyUser,
  getMenuTree,
  getRoleMenuTree,
  saveRoleMenus
} from "@/api/userMG";
import { formatDate } from '@/utils/format';

export default {
  name: "RoleManagement",
  data() {
    return {
      // 角色管理相关数据
      roleDialogVisible: false, // 角色添加/编辑对话框
      roleDialogType: 'add', // 角色对话框类型：add-新增，edit-编辑
      roleTable: [], // 角色列表
      roleForm: {
        roleName: '',
        roleRemark: '',
        powerId: '', // 逗号分隔的权限ID字符串
        menuIds: [], // 新增：选中的菜单ID列表
        roleStatus: '0', // 默认启用
        companyId: null,
        createBy: null
      },
      roleRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      roleLoading: false,
      
      // 用户角色分配相关
      assignRoleDialogVisible: false,
      selectedUser: null, // 当前选中的用户
      roleUsers: [], // 当前角色已分配的用户列表
      currentRole: null, // 当前选中的角色
      systemCompanyUser0: [], // 组织成员列表
      
      // 权限列表数据
      powerList: [], // 所有权限列表
      powerProps: { // 权限树属性
        label: 'powerName',
        children: 'children'
      },
      
      // 菜单列表数据
      menuList: [],
      menuProps: {
        label: 'menuName',
        children: 'children'
      },
      
      // 调试功能标志
      debugMode: true,

      // 当前用户和组织信息
      user: {},
      company: {},

      loading: false,
      submitLoading: false,
      roleList: [],
      query: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      menuLoading: false
    };
  },
  created() {
    try {
      // 从localStorage获取用户和公司信息
      this.user = JSON.parse(localStorage.getItem('userdata') || '{}');
      this.company = JSON.parse(localStorage.getItem('company') || '{}');
      if(!this.company) return ;

      console.log('角色管理组件初始化 - 当前用户:', this.user.userId, '当前组织:', this.company.companyId);
      
      // 初始化加载数据
      this.loadPowerList();
      this.loadRoleList();
      this.loadOrgMembers();
      this.loadMenuList();
    } catch (error) {
      console.error('角色管理组件初始化失败:', error);
      // this.$message.error('组件初始化失败，请刷新页面重试');
    }
  },
  computed: {
    // 判断当前用户是否为组织创建者
    isOrgCreator() {
      return this.company && this.user && this.company.userId === this.user.userId;
    }
  },
  filters: {
    timestampToTime(timestamp) {
      if (!timestamp) {
        return '';
      }
      return formatDate(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss');
    }
  },
  methods: {
    // 日志工具函数
    logInfo(message, data) {
      if (this.debugMode) {
        console.log(`[角色管理] ${message}`, data !== undefined ? data : '');
      }
    },
    
    logWarn(message, data) {
      console.warn(`[角色管理] ${message}`, data !== undefined ? data : '');
    },
    
    logError(message, data) {
      console.error(`[角色管理] ${message}`, data !== undefined ? data : '');
    },
    
    // 用于主动刷新当前角色的菜单权限
    async refreshCurrentRoleMenus() {
      if (!this.roleForm.roleId) {
        console.error('无法刷新菜单权限：角色ID为空');
        this.$message.error('无法获取角色信息');
        return Promise.reject(new Error('角色ID为空'));
      }
      
      this.menuLoading = true;
      console.log('开始刷新角色菜单权限，角色ID:', this.roleForm.roleId);
      
      try {
        const res = await getRoleMenuTree(this.roleForm.roleId);
        console.log('获取角色菜单树完整响应:', JSON.stringify(res));
        
        // 尝试从不同格式中提取菜单ID列表
        let menuIds = [];
        
        if (res && res.code === 200) {
          if (Array.isArray(res.data)) {
            menuIds = res.data;
          } else if (res.data && res.data.checkedKeys && Array.isArray(res.data.checkedKeys)) {
            menuIds = res.data.checkedKeys;
          } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
            menuIds = res.data.data;
          } else if (res.data && res.data.status === 200) {
            if (res.data.data && Array.isArray(res.data.data)) {
              menuIds = res.data.data;
            }
          } else if (typeof res.data === 'object' && res.data !== null) {
            const possibleIds = Object.values(res.data).filter(val => 
              typeof val === 'number' || (typeof val === 'string' && !isNaN(parseInt(val, 10)))
            );
            if (possibleIds.length > 0) {
              menuIds = possibleIds;
            }
          }
          
          // 过滤无效的ID值并统一处理ID格式
          menuIds = menuIds
            .filter(id => id !== null && id !== undefined && id !== '')
            .map(id => {
              if (typeof id === 'object' && id !== null) {
                return id.id || id.menuId || id;
              }
              return String(id);
            });
          
          console.log('最终解析得到的菜单ID列表:', menuIds);
          
          // 设置菜单ID到表单
          this.roleForm.menuIds = menuIds;
          
          // 确保menuIds在menuTree组件中生效
          this.$nextTick(() => {
            if (this.$refs.menuTree) {
              console.log('设置菜单树选中状态，菜单ID:', menuIds);
              
              // 先清空当前选中状态，再设置新的选中状态
              this.$refs.menuTree.setCheckedKeys([]);
              
              // 等待一小段时间确保清空操作完成
              setTimeout(() => {
                this.$refs.menuTree.setCheckedKeys(menuIds);
              }, 100);
            } else {
              console.warn('菜单树组件尚未渲染，无法设置选中状态');
            }
          });
          
          return Promise.resolve(menuIds);
        } else {
          const errorMsg = (res.msg || (res.data && res.data.message) || '未知错误');
          console.error('获取角色菜单树请求失败:', errorMsg);
          this.$message.error('获取角色菜单权限失败：' + errorMsg);
          return Promise.reject(new Error(errorMsg));
        }
      } catch (err) {
        console.error('请求角色菜单权限接口异常:', err);
        this.$message.error('获取角色菜单权限失败: ' + (err.message || JSON.stringify(err)));
        return Promise.reject(err);
      } finally {
        this.menuLoading = false;
      }
    },
    
    loadOrgMembers() {
      if (!this.company || !this.company.companyId) {
        this.$message.error('无法获取组织信息');
        return;
      }

      // 确保组织成员列表初始化为空数组
      this.systemCompanyUser0 = [];
      this.roleLoading = true;
      
      console.log('开始加载组织成员，组织ID:', this.company.companyId);
      
      // 获取组织成员列表
      getCompanyUser('', this.company.companyId).then(res => {
        try {
          console.log('组织成员API响应:', JSON.stringify(res));
          
          if (!res) {
            console.error('API返回空响应');
            this.$message.error('获取组织成员失败：空响应');
            return;
          }
          
          // 检查标准响应格式
          if (res.code === 200) {
            // 后端现在直接返回数组形式的成员列表
            if (!res.data) {
              console.warn('API返回成功但data为空');
              this.systemCompanyUser0 = [];
              return;
            }
            
            let memberData = res.data;
            // 确保memberData是数组
            if (!Array.isArray(memberData)) {
              console.warn('返回数据不是数组，尝试转换:', memberData);
              // 尝试从对象中获取数组
              if (memberData.systemCompanyUser0 && Array.isArray(memberData.systemCompanyUser0)) {
                memberData = memberData.systemCompanyUser0;
              } else {
                memberData = [];
              }
            }
            
            console.log('成功加载组织成员', memberData.length + '个成员');
            
            // 规范化成员数据，确保每个成员对象都有必要的字段
            this.systemCompanyUser0 = memberData.map(item => {
              // 如果缺少user字段或user字段不完整，使用item本身的字段创建
              if (!item.user || (!item.user.userName && !item.user.userPhone)) {
                return {
                  ...item,
                  user: {
                    userId: item.userId || item.id || '',
                    userName: item.userName || item.name || '未知用户',
                    userPhone: item.userPhone || item.phone || '',
                    userEmail: item.userEmail || item.email || ''
                  }
                };
              }
              return item;
            });
            
            if (this.systemCompanyUser0.length > 0) {
              const sampleMember = this.systemCompanyUser0[0];
              console.log('成员数据样例:', JSON.stringify(sampleMember));
            }
          } else {
            console.error('获取组织成员返回异常', res);
            this.$message.error(res.msg || '获取组织成员失败');
          }
        } catch (error) {
          console.error('处理组织成员数据异常:', error);
          this.$message.error('处理组织成员数据异常: ' + error.message);
          this.systemCompanyUser0 = [];
        } finally {
          this.roleLoading = false;
        }
      }).catch(err => {
        console.error('获取组织成员失败', err);
        this.$message.error('获取组织成员失败: ' + (err.message || JSON.stringify(err)));
        this.systemCompanyUser0 = [];
        this.roleLoading = false;
      });
    },
    async openRoleDialog(type, row) {
      this.roleDialogVisible = true;
      this.roleDialogType = type;
      
      if (type === 'edit') {
        this.roleForm = { ...row };
        // 添加菜单加载状态
        this.menuLoading = true;
        
        // 如果有权限ID，设置树形控件选中状态
        if (this.roleForm.powerId && this.$refs.powerTree) {
          this.$refs.powerTree.setCheckedKeys(this.roleForm.powerId.split(','));
        }
        
        // 在编辑模式下，自动刷新菜单权限
        try {
          // 1. 重新加载菜单树数据
          await this.loadMenuList();
          
          // 2. 加载角色的菜单权限
          if (this.roleForm.roleId) {
            await this.refreshCurrentRoleMenus();
          }
        } catch (error) {
          console.error('加载菜单权限数据出错:', error);
          this.$message.error('加载菜单权限失败: ' + error.message);
        } finally {
          this.menuLoading = false;
        }
      } else {
        // 新增角色时，设置公司ID和createBy为当前用户ID
        this.roleForm = {
          roleName: '',
          roleRemark: '',
          powerId: '',
          menuIds: [],
          roleStatus: '0',
          companyId: this.company.companyId,
          createBy: this.user.userId
        };
        // 重置树形控件选中状态
        if (this.$refs.powerTree) {
          this.$refs.powerTree.setCheckedKeys([]);
        }
        
        // 加载最新的菜单树
        this.loadMenuList();
      }
    },
    loadRoleList() {
      if (!this.company || !this.company.companyId) {
        this.$message.error('无法获取组织信息');
        return;
      }
      
      this.roleLoading = true;
      getRoleList(this.company.companyId).then(res => {
        console.log('获取角色列表响应:', res);
        if (res.code === 200) {
          this.roleTable = res.data || [];
          console.log('角色列表数据:', this.roleTable);
        } else {
          this.$message.error(res.msg || '获取角色列表失败');
        }
        this.roleLoading = false;
      }).catch(err => {
        console.error('获取角色列表失败', err);
        this.$message.error('获取角色列表失败');
        this.roleLoading = false;
      });
    },
    toggleRoleStatus(row) {
      const status = row.roleStatus === '0' ? '1' : '0';
      enableOrDisableRole(row.roleId, status).then(res => {
        if (res.code === 200) {
          this.$message.success(`角色状态已更新为${status === '0' ? '正常' : '停用'}`);
          this.loadRoleList();
        } else {
          this.$message.error('更新角色状态失败');
        }
      }).catch(err => {
        console.error('更新角色状态失败', err);
        this.$message.error('更新角色状态失败');
      });
    },
    assignRole(row) {
      this.assignRoleDialogVisible = true;
      this.currentRole = row;
      this.selectedUser = null;
      
      // 记录当前操作的角色
      console.log('正在分配角色:', row.roleName, '角色ID:', row.roleId);
      
      // 检查组织成员是否已加载，如果未加载则重新加载
      if (!this.systemCompanyUser0 || this.systemCompanyUser0.length === 0) {
        console.log('组织成员未加载或为空，重新加载');
        this.loadOrgMembers();
      }
      
      // 加载该角色已分配的成员列表
      this.loadRoleUsers(row.roleId);
    },
    
    loadRoleUsers(roleId) {
      this.roleLoading = true;
      this.roleUsers = [];
      
      getRoleUserList(roleId).then(res => {
        if (res.code === 200) {
          this.roleUsers = res.data || [];
        } else {
          this.$message.error(res.msg || '获取角色成员列表失败');
        }
        this.roleLoading = false;
      }).catch(err => {
        console.error('获取角色成员列表失败', err);
        this.$message.error('获取角色成员列表失败');
        this.roleLoading = false;
      });
    },
    handleDeleteRole(row) {
      // 打印角色信息以帮助诊断问题
      console.log('准备删除角色:', row);
      console.log('角色ID (roleId):', row.roleId, '类型:', typeof row.roleId);
      
      // 如果roleId为空，显示错误消息
      if (!row.roleId) {
        this.$message.error('删除失败: 角色ID为空');
        return;
      }
      
      this.$confirm('确认要删除该角色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确保roleId是字符串类型
        const roleId = String(row.roleId);
        console.log('发送删除请求，角色ID:', roleId);
        
        // 捕获详细的错误信息
        try {
          deleteRole(roleId).then(res => {
            console.log('删除角色响应:', res);
            if (res.code === 200) {
              this.$message.success('角色删除成功');
              this.loadRoleList();
            } else {
              console.error('后端返回错误:', res.msg);
              this.$message.error(res.msg || '删除角色失败');
            }
          }).catch(err => {
            console.error('删除角色API调用失败:', err);
            this.$message.error('删除角色失败: ' + (err.message || JSON.stringify(err)));
          });
        } catch (error) {
          console.error('删除角色过程中发生异常:', error);
          this.$message.error('删除角色发生异常: ' + error.message);
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 角色管理相关方法
    resetRoleForm() {
      this.roleForm = {
        roleName: '',
        roleRemark: '',
        powerId: '',
        menuIds: [],
        roleStatus: '0',
        companyId: this.company ? this.company.companyId : null,
        createBy: this.user ? this.user.userId : null
      };
      if (this.$refs.powerTree) {
        this.$refs.powerTree.setCheckedKeys([]);
      }
    },
    
    handlePowerCheck() {
      // 获取全量的权限信息
      const allPowerNodes = this.getAllPowerNodes(this.powerList);
      const checkedKeys = this.$refs.powerTree.getCheckedKeys();
      const halfCheckedKeys = this.$refs.powerTree.getHalfCheckedKeys();
      
      // 将权限数据转换为包含选中状态的完整数据结构
      const powerData = allPowerNodes.map(power => {
        return {
          powerId: power.powerId,
          checked: checkedKeys.includes(power.powerId),
          halfChecked: halfCheckedKeys.includes(power.powerId)
        };
      });
      
      // 保存完整的权限数据
      this.roleForm.powerData = powerData;
      // 同时保持原有的powerId字段兼容性
      this.roleForm.powerId = checkedKeys.join(',');
    },
    
    // 递归获取所有权限节点
    getAllPowerNodes(nodes) {
      let allNodes = [];
      if (!nodes || nodes.length === 0) return allNodes;
      
      nodes.forEach(node => {
        allNodes.push(node);
        if (node.children && node.children.length > 0) {
          allNodes = allNodes.concat(this.getAllPowerNodes(node.children));
        }
      });
      
      return allNodes;
    },
    
    loadPowerList() {
      getPowerList().then(res => {
        if (res.code === 200) {
          this.powerList = res.data || [];
        } else {
          this.$message.error(res.msg || '获取权限列表失败');
        }
      }).catch(err => {
        console.error('获取权限列表失败', err);
        this.$message.error('获取权限列表失败');
      });
    },
    
    async submitRoleForm() {
      this.$refs.roleForm.validate(async valid => {
        if (!valid) {
          return false;
        }
        
        // 避免重复提交
        if (this.submitLoading) {
          return;
        }
        this.submitLoading = true;
        
        try {
          // 确保权限数据是最新的
          if (this.$refs.powerTree) {
            this.handlePowerCheck();
          }
          
          // 基本角色信息
          const roleData = {
            roleName: this.roleForm.roleName,
            roleRemark: this.roleForm.roleRemark || '',
            roleStatus: this.roleForm.roleStatus || '0',
            companyId: this.roleForm.companyId || this.company.companyId,
            powerData: this.roleForm.powerData, // 添加完整的权限数据
            powerId: this.roleForm.powerId // 保留原有的powerId字段
          };
          
          // 如果是编辑模式，添加角色ID
          if (this.roleDialogType === 'edit' && this.roleForm.roleId) {
            roleData.roleId = this.roleForm.roleId;
          }
          
          // 添加角色菜单权限相关信息（如果在表单中定义了）
          if (this.$refs.menuTree) {
            // 只获取选中的节点，不包括半选节点
            const checkedKeys = this.$refs.menuTree.getCheckedKeys();
            
            console.log('提交表单中的菜单ID:', checkedKeys.length + '个');
            
            // 将菜单ID保存到表单中，便于后续处理
            this.roleForm.menuIds = checkedKeys;
            roleData.menuIds = checkedKeys;
          }
          
          console.log('角色表单最终数据:', roleData);
          
          // 保存角色基本信息
          const res = await (this.roleDialogType === 'add' ? addRole(roleData) : editRole(roleData));
          
          if (res && res.code === 200) {
            // 获取角色ID（新增时从返回值获取，编辑时从表单获取）
            const roleId = this.roleDialogType === 'add' 
              ? (res.data && res.data.roleId || res.data) 
              : this.roleForm.roleId;
            
            console.log('角色保存成功，角色ID:', roleId);
            
            // 保存角色菜单信息
            try {
              // 确保有角色ID和菜单ID
              if (roleId && this.roleForm.menuIds && this.roleForm.menuIds.length > 0) {
                console.log('准备保存角色菜单权限，角色ID:', roleId, '菜单IDs:', this.roleForm.menuIds);
                
                // 准备菜单ID参数
                let menuIdsStr;
                if (Array.isArray(this.roleForm.menuIds)) {
                  // 如果是数组，直接使用
                  menuIdsStr = this.roleForm.menuIds;
                } else if (typeof this.roleForm.menuIds === 'string') {
                  // 如果是字符串，转为数组
                  menuIdsStr = this.roleForm.menuIds.split(',').filter(id => id.trim() !== '');
                } else {
                  console.warn('无法处理的menuIds格式:', typeof this.roleForm.menuIds);
                  menuIdsStr = [];
                }
                
                if (menuIdsStr && menuIdsStr.length > 0) {
                  console.log('发送保存角色菜单请求, 参数:', roleId, menuIdsStr);
                  // API要求单独传入roleId和menuIds两个参数
                  const res = await saveRoleMenus(roleId, menuIdsStr);
                  console.log('保存角色菜单响应:', res);
                  
                  if (res && res.code !== 200) {
                    // 仅记录错误但不中断流程
                    console.error('保存菜单权限失败:', res.msg || '未知错误');
                    // 显示警告但不阻止关闭对话框
                    this.$message.warning('角色基本信息已保存，但菜单权限保存失败，请稍后重试');
                  } else {
                    // 菜单权限已更新，触发全局事件通知系统刷新菜单
                    this.triggerMenuPermissionsUpdate();
                  }
                }
              } else {
                console.warn('缺少必要参数，跳过保存菜单权限', 
                  'roleId:', roleId, 
                  'menuIds:', this.roleForm.menuIds ? this.roleForm.menuIds.length : 'null');
              }
            } catch (menuErr) {
              console.error('保存角色菜单关联异常:', menuErr);
              // 显示警告但不阻止关闭对话框
              this.$message.warning('角色基本信息已保存，但菜单权限保存过程中发生错误');
            }
            
            // 成功消息
            this.$message.success(this.roleDialogType === 'add' ? '添加成功' : '更新成功');
            // 关闭对话框
            this.roleDialogVisible = false;
            
            // 给一点时间让后端处理数据
            setTimeout(() => {
              // 刷新角色列表
              this.loadRoleList();
            }, 500);
          } else {
            // 错误处理
            const errorMsg = (res.msg || (res.data && res.data.message) || '未知错误');
            console.error('保存角色失败:', errorMsg);
            this.$message.error('操作失败：' + errorMsg);
          }
        } catch (err) {
          console.error('保存角色信息失败：', err);
          this.$message.error('保存失败，请稍后重试');
        } finally {
          this.submitLoading = false;
        }
      });
    },
    
    submitAssignRole() {
      if (!this.selectedUser) {
        this.$message.warning('请选择用户');
        return;
      }
      
      if (!this.currentRole || !this.currentRole.roleId) {
        this.$message.warning('角色信息不完整');
        return;
      }
      
      // 显示加载状态
      this.roleLoading = true;
      
      // 创建用户角色请求
      const params = {
        userId: this.selectedUser,
        roleId: this.currentRole.roleId
      };
      
      addUserRole(params).then(res => {
        if (res.code === 200) {
          this.$message.success('分配角色成功');
          // 重新加载角色成员列表
          this.loadRoleUsers(this.currentRole.roleId);
          // 重置选择
          this.selectedUser = null;
        } else {
          this.$message.error(res.msg || '分配角色失败');
        }
        this.roleLoading = false;
      }).catch(err => {
        console.error('分配角色失败', err);
        this.$message.error('分配角色失败');
        this.roleLoading = false;
      });
    },
    
    removeUserFromRole(row) {
      if (!row || !row.id) {
        this.$message.error('用户角色信息不完整');
        return;
      }
      
      this.$confirm('确定要移除此用户的角色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteUserRole(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success('移除成功');
            // 重新加载角色成员列表
            this.loadRoleUsers(this.currentRole.roleId);
          } else {
            this.$message.error(res.msg || '移除失败');
          }
        }).catch(err => {
          console.error('移除用户角色失败', err);
          this.$message.error('移除用户角色失败');
        });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    handleMenuCheck() {
      // 获取选中的菜单ID
      const checkedKeys = this.$refs.menuTree.getCheckedKeys();
      console.log('菜单树选中状态变化，选中的ID:', checkedKeys);
      // 不再包含半选状态的节点
      this.roleForm.menuIds = checkedKeys;
    },
    // 加载菜单树
    loadMenuList() {
      return new Promise((resolve, reject) => {
        getMenuTree().then(res => {
          try {
            if (res.code === 200) {
              if (Array.isArray(res.data)) {
                this.menuList = this.processMenuItems(res.data);
              } else if (res.data && res.data.menus && Array.isArray(res.data.menus)) {
                this.menuList = this.processMenuItems(res.data.menus);
              } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
                this.menuList = this.processMenuItems(res.data.data);
              } else if (res.data && res.data.status === 200 && res.data.data) {
                this.menuList = this.processMenuItems(Array.isArray(res.data.data) ? res.data.data : []);
              } else {
                console.warn('响应code正确但无法解析菜单数据:', res.data);
                this.menuList = [];
              }
              
              resolve(this.menuList);
            } else {
              // 错误处理
              let errorMsg = '未知错误';
              
              if (res && res.msg) {
                errorMsg = res.msg;
              } else if (res && res.data && typeof res.data === 'object' && res.data.message) {
                errorMsg = res.data.message;
              } else if (typeof res === 'string') {
                errorMsg = res;
              }
              
              console.error('获取菜单树失败:', errorMsg);
              this.$message.error('获取菜单树失败：' + errorMsg);
              this.menuList = [];
              reject(new Error(errorMsg));
            }
          } catch (parseError) {
            console.error('解析菜单树数据时出错:', parseError);
            this.$message.error('解析菜单数据失败: ' + parseError.message);
            this.menuList = [];
            reject(parseError);
          }
        }).catch(err => {
          console.error('请求菜单树API时出错:', err);
          this.$message.error('获取菜单树失败: ' + (err.message || JSON.stringify(err)));
          this.menuList = [];
          reject(err);
        });
      });
    },
    
    // 统一处理菜单项，确保id字段一致
    processMenuItems(items) {
      if (!items || !Array.isArray(items)) return [];
      
      return items.map(item => {
        // 确保每个菜单项有id字段(可能是menuId或id)
        const processedItem = { 
          ...item,
          id: item.id || item.menuId, // 使用id作为统一标识
          label: item.label || item.menuName // 确保有label用于显示
        };
        
        // 处理子菜单
        if (item.children && Array.isArray(item.children)) {
          processedItem.children = this.processMenuItems(item.children);
        }
        
        return processedItem;
      });
    },

    getUserLabel(item) {
      if (!item) return '未知用户';
      
      // 首先尝试通过user对象获取信息
      if (item.user && item.user.userName) {
        return `${item.user.userName}(${item.user.userPhone || '无手机号'})`;
      } 
      
      // 然后尝试直接从item获取
      if (item.userName || item.name) {
        const userName = item.userName || item.name;
        const userPhone = item.userPhone || item.phone || '无手机号';
        return `${userName}(${userPhone})`;
      } 
      
      // 最后尝试使用user id作为标识
      if (item.userId || item.id) {
        return `用户ID: ${item.userId || item.id}`;
      }
      
      // 如果什么都没有，返回未知
      return '未知用户';
    },
    getUserDisplayField(item, field) {
      if (!item) return '未知';
      
      // Define mappings for alternative field names
      const fieldMappings = {
        'userName': ['name', 'username', 'user_name'],
        'userPhone': ['phone', 'mobile', 'telephone'],
        'userEmail': ['email', 'mail']
      };
      
      // 检查user对象中是否有该字段
      if (item.user && item.user[field]) {
        return item.user[field];
      }
      
      // 检查item对象本身是否有该字段
      if (item[field]) {
        return item[field];
      }
      
      // 检查替代字段名
      if (fieldMappings[field]) {
        for (const altField of fieldMappings[field]) {
          // 检查user对象中的替代字段
          if (item.user && item.user[altField]) {
            return item.user[altField];
          }
          // 检查item对象中的替代字段
          if (item[altField]) {
            return item[altField];
          }
        }
      }
      
      return '未知';
    },
    // 触发菜单权限更新事件
    triggerMenuPermissionsUpdate() {
      console.log('角色菜单权限已更新，触发全局刷新事件');
      
      // 清除当前用户的菜单权限缓存，强制重新加载
      localStorage.removeItem('userMenuPermissions');
      
      // 触发自定义事件，通知系统刷新菜单
      window.dispatchEvent(new CustomEvent('menu-permissions-updated'));
      
      // 获取当前登录用户的角色ID列表
      const currentUserRoles = this.getCurrentUserRoles();
      
      // 如果当前修改的是用户自己所属的角色之一，提示用户刷新页面
      if (currentUserRoles && currentUserRoles.includes(this.roleForm.roleId)) {
        console.log('用户修改了自己所属的角色权限，将在3秒后自动刷新页面');
        this.$message.info('您修改了自己所属角色的权限，系统将在3秒后刷新页面以应用新权限');
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    },
    
    // 获取当前登录用户的角色ID列表
    getCurrentUserRoles() {
      try {
        const rolesPower = localStorage.getItem('sysRolePower');
        if (!rolesPower) return [];
        
        const roles = JSON.parse(rolesPower);
        return roles.map(role => role.roleId);
      } catch (error) {
        console.error('获取当前用户角色失败:', error);
        return [];
      }
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  color: #000000;
}

.mainCard3 {
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  height: auto;
  /* 移除固定高度限制 */
}

.mainCard3 >>> .el-table__cell {
  border: 0px;
}
.buttonB {
  margin-right: 10px;
}
.btnactive {
  background-color: #409eff;
  color: #fff;
}
:global{
  .el-table__empty-block{
    height: auto !important;
  }
}
</style> 


// WEBPACK FOOTER //
// src/views/auth/roleManagement.vue